var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "memorandum_create_block small" }, [
    _c("div", { staticClass: "list_mem_create" }, [
      _c("div", { staticClass: "panel" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "panel-container show" }, [
          _c("div", { staticClass: "panel-content" }, [
            !_vm.obj_to_null(this.user)
              ? _c("div", { staticClass: "user_add" }, [
                  _c(
                    "div",
                    {
                      staticClass: "add user cursor-pointer fs-xxl",
                      on: { click: _vm.add_user },
                    },
                    [
                      _c("i", {
                        staticClass:
                          "fal add_user fa-plus-square color-primary-100 pr-3",
                        attrs: { title: "", "data-type": "delegate_users" },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Оберіть користувача")]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.obj_to_null(this.user)
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-6 col-lg-6 col-md-5 col-xs-12" },
                    [
                      _c(
                        "b-card",
                        {
                          attrs: { "no-body": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("h4", { staticClass: "mb-0" }, [
                                      _vm._v("Переміщення з "),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1049166508
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-card-body",
                            [
                              _vm.obj_to_null(this.user)
                                ? _c("user_block", {
                                    key: _vm.user.id,
                                    attrs: {
                                      can_del: true,
                                      del_triger: _vm.remove_selected_user,
                                      user: _vm.user,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "next_step pt-3" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-lg btn-outline-primary",
                                    attrs: { disabled: !_vm.can_save },
                                    on: { click: _vm.save },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            Створити\n                                        "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 col-lg-6 col-md-5 col-xs-12" },
                    [
                      _c(
                        "b-card",
                        {
                          attrs: { "no-body": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("h4", { staticClass: "mb-0" }, [
                                      _vm._v("Переміщення в "),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3370995113
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-card-body",
                            [
                              _c(
                                "b-row",
                                { staticClass: "doc_title" },
                                [
                                  _c("b-col", { attrs: { sm: "3" } }, [
                                    _c("label", { attrs: { for: "srv_lst" } }, [
                                      _vm._v("Кластер *"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "4" } },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "srv_lst",
                                          options: _vm.form.srv_list,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.form.cluster_id,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "cluster_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.cluster_id",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "doc_title" },
                                [
                                  _c("b-col", { attrs: { sm: "3" } }, [
                                    _c("label", { attrs: { for: "u_dep" } }, [
                                      _vm._v("Організація *"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "4" } },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "srv_lst",
                                          options: _vm.form.company_list,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.form.company,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "company", $$v)
                                          },
                                          expression: "form.company",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "doc_title" },
                                [
                                  _c("b-col", { attrs: { sm: "3" } }, [
                                    _c("label", { attrs: { for: "u_dep" } }, [
                                      _vm._v("Вiддiл *"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "4" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          maxlength: "120",
                                          id: "u_dep",
                                          size: "sm",
                                        },
                                        model: {
                                          value: _vm.form.department,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "department",
                                              $$v
                                            )
                                          },
                                          expression: "form.department",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "doc_title" },
                                [
                                  _c("b-col", { attrs: { sm: "3" } }, [
                                    _c("label", { attrs: { for: "u_dep" } }, [
                                      _vm._v("Посада *"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "4" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          maxlength: "120",
                                          id: "u_dep",
                                          size: "sm",
                                        },
                                        model: {
                                          value: _vm.form.dolznost,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "dolznost", $$v)
                                          },
                                          expression: "form.dolznost",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "panel-hdr bg-primary-500 bg-success-gradient" },
      [
        _c("h2", [
          _c("span", { staticClass: "icon-stack fs-xxl mr-2" }, [
            _c("i", {
              staticClass:
                "base base-7 icon-stack-3x opacity-100 color-primary-500",
            }),
            _vm._v(" "),
            _c("i", {
              staticClass:
                "base base-7 icon-stack-2x opacity-100 color-primary-400",
            }),
            _vm._v(" "),
            _c("i", {
              staticClass:
                "fal fa-people-arrows icon-stack-1x opacity-100 color-white fa-spin",
            }),
          ]),
          _vm._v(
            "\n                    Переміщення користувача\n                "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "panel-toolbar" }, [
          _c("button", {
            staticClass: "btn btn-panel waves-effect waves-themed",
            attrs: {
              "data-action": "panel-fullscreen",
              "data-toggle": "tooltip",
              "data-offset": "0,10",
              "data-original-title": "Fullscreen",
            },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }